export var MIN_PHONE_WIDTH = 320;
export var MIN_TABLET_WIDTH = 768;
export var MIN_DESKTOP_WIDTH = 1025;